import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { platformApi } from '../../../../api/endpoints/platform';
import {
    tenantCatalogQueryOptions,
    useTenantLabelResolver,
} from '../../../../hooks/useTenantLabelResolver';
import { PermissionMatrixView } from '../../../../components/tenant/PermissionMatrixView';

/** Matriz del tenant que ve un actor de plataforma: roles, catálogo y etiquetas de ESE tenant. */
export function PlatformTenantPermissionMatrix({ tenantId }: { tenantId: string }) {
    const labels = useTenantLabelResolver(tenantId);

    const rolesQ = useQuery({
        queryKey: ['platform', 'tenants', tenantId, 'roles'],
        queryFn: () => platformApi.listTenantRoles(tenantId),
        enabled: !!tenantId,
    });
    const catalogQ = useQuery(tenantCatalogQueryOptions(tenantId));

    const roles = useMemo(() => rolesQ.data?.items ?? [], [rolesQ.data]);
    const catalog = useMemo(() => catalogQ.data?.items ?? [], [catalogQ.data]);

    return (
        <PermissionMatrixView
            roles={roles}
            catalog={catalog}
            labels={labels}
            isPending={rolesQ.isPending || catalogQ.isPending}
            isError={rolesQ.isError || catalogQ.isError}
            onRetry={() => {
                if (rolesQ.isError) void rolesQ.refetch();
                if (catalogQ.isError) void catalogQ.refetch();
            }}
        />
    );
}
